import React from 'react';
import { Star, Quote } from 'lucide-react';
import { businessData } from '../data/mock';
import './Reviews.css';

const Reviews = () => {
  const fullStars = Math.floor(businessData.reputation.rating);
  const hasHalfStar = businessData.reputation.rating % 1 >= 0.5;

  return (
    <section id="opiniones" className="reviews section">
      <div className="reviews__container container">
        <div className="reviews__header">
          <h2 className="section-title">Lo que dicen nuestros clientes</h2>
          <div className="reviews__rating-summary">
            <div className="reviews__stars">
              {[...Array(5)].map((_, i) => (
                <Star 
                  key={i} 
                  size={24} 
                  className={i < fullStars || (i === fullStars && hasHalfStar) ? 'star' : 'star-empty'}
                  fill={i < fullStars ? 'currentColor' : 'none'}
                />
              ))}
            </div>
            <span className="reviews__rating-number">{businessData.reputation.rating}</span>
            <span className="reviews__rating-count">({businessData.reputation.totalReviews} opiniones en Google)</span>
          </div>
        </div>
        
        <div className="reviews__highlights">
          <h3 className="reviews__highlights-title">Los clientes destacan:</h3>
          <div className="reviews__highlights-list">
            {businessData.reputation.frequentOpinions.map((opinion, index) => (
              <span key={index} className="reviews__highlight-badge">
                {opinion}
              </span>
            ))}
          </div>
        </div>
        
        <div className="reviews__grid">
          {businessData.reviews.map((review, index) => (
            <div key={index} className="reviews__card card">
              <Quote size={32} className="reviews__card-icon" />
              <p className="reviews__card-text">"{review.text}"</p>
              <span className="reviews__card-author">— {review.author}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
